<template>
  <section class="wrapper__tabs">
      <div class="bg">
          <div class="tabs__container">
              <div class="tabs-header">
                  <button
                  v-for="tab in tabs"
                  :key="tab.id"
                  :class="['tab-button', { active: activeTab === tab.id }]"
                  @click="selectTab(tab.id)"
                  >
                  {{ tab.title }}
                  </button>
              </div>
          </div>
      </div>
      <div class="tabs__container">
          <div class="tabs-content">
              <template v-if="activeTab == 1"><Description :array="tabs_description"></Description></template>
              <template v-if="activeTab == 2"><Specifications :array="technical_specifications"></Specifications></template>
              <template v-if="activeTab == 3"><Reviews :array="reviews"></Reviews></template>
              <template v-if="activeTab == 4"><Delivery></Delivery></template>
          </div>
      </div>
  </section>  
</template>

<script>
import Delivery from './Tabs/Delivery.vue';
import Specifications from './Tabs/Specifications.vue';
import Reviews from './Tabs/Reviews.vue';
import Description from './Tabs/Description.vue';
export default {
  components: {
      Delivery,
      Specifications,
      Reviews,
      Description,
  },
  props: {
    tabs_description: [Array,Object],
    technical_specifications: [Array,Object],
    reviews: [Array,Object],
  },
  name: "Tabs",
  data() {
    return {
      activeTab: 1,
      tabs: [
        { id: 1, title: "Description", component: "TabContent1" },
        { id: 2, title: "Components", component: "TabContent2" },
        // { id: 3, title: "Reviews", component: "TabContent3" },
        { id: 4, title: "Delivery", component: "TabContent4" },
      ],
    };
  },
  computed: {
    currentTabComponent() {
      return this.tabs.find((tab) => tab.id === this.activeTab)?.component;
    },
  },
  methods: {
    selectTab(tabId) {
      this.activeTab = tabId;
    },
  },
};
</script>

<style scoped>
.wrapper__tabs{
  padding-bottom: 112px;
}
.bg{
  background: rgba(222, 230, 234, 0.5);
}
.tabs-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.tabs-header {
  display: flex;
}

.tab-button {
  color: rgb(5, 5, 5);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  height: 64px;
  padding: 0 24px;
  text-align: center;
  border: none;
  background-color: #f1f1f1;
  cursor: pointer;
  transition: background-color 0.3s;
}

.tab-button.active {
  background-color: rgb(255, 255, 255);
}

.tab-button:hover:not(.active) {
  background-color: #ddd;
}
@media (max-width:1024px) {
  .wrapper__tabs{
    padding-bottom: unset;
  }
}
@media (max-width: 768px) {
  .tab-button{
      padding: 0 12px;
  }
  .tabs-header {
    flex-direction: column;

  }
  .tabs__container{
    padding: unset;
  }
  .tabs-content{
    padding: 0 20px;
  }
  .wrapper__tabs{
    padding-bottom: unset;
  }
}
</style>
